import SingleTextLoader from 'organisms/Loaders/SingleTextLoader';

export default function ({ item, isLoading }) {
  if (isLoading) return <SingleTextLoader />;

  const visits = item?.visits;
  if (!visits) return <p>-</p>;

  return <p className="ellipsis">{visits}</p>;
}
